import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

import { useStakeDebit } from "../../CustomHooks/Queries";
import { useVerifyPersonSynctera } from "../../CustomHooks/Mutations";

import useStakeCheckingStatusAction from "../../CustomHooks/useStakeCheckingStatusAction";

import { getStakeDebitAPIObject } from "../../Utils/api-data-transforms";
import { dispatchAPIErrorToast, isMobileDevice, isSVDPendingVerification } from "../../Utils/helpers";
import { contactStakeIfErrorPersistsMessage, isDevReactEnv } from "../../Utils/constants";

import { StakeLogo } from "../../Assets/Images";
import { ArrowLeft, CloseWithShadow } from "../../Assets/Icons";

import "./verify-stake-checking.scss";

const onSyncteraVerifyError = () => {
  dispatchAPIErrorToast({
    key: "verifyStakeChecking",
    autoHideDuration: null,
  });
};

export default function VerifyStakeChecking() {
  const [isSDKLoaded, setIsSDKLoaded] = useState(false);
  const [isSDKLoadingError, setIsSDKLoadingError] = useState(false);

  const navigate = useNavigate();
  const { state: locationState } = useLocation();

  const { isFetching: isFetchingStakeDebit, data: stakeDebit } = useStakeDebit();

  const stakeCheckingStatusAction = useStakeCheckingStatusAction();

  const { mutate: VerifyPersonSynctera } = useVerifyPersonSynctera({
    onSuccess: ({ data }) => {
      stakeCheckingStatusAction(getStakeDebitAPIObject(data?.data?.stake_checking_status));
      navigate(locationState?.previousPathname || -1);
    },
    onError: onSyncteraVerifyError,
  });

  useEffect(() => {
    if (!isFetchingStakeDebit && !isSDKLoaded) {
      if (isSVDPendingVerification(stakeDebit?.data)) {
        var config = {
          onProgress: (e) => {
            if (isDevReactEnv) {
              console.log(e);
            }
          },
          onSuccess: ({ docvTransactionToken }) => {
            VerifyPersonSynctera({
              person_id: stakeDebit?.data?.data?.unit_customer_id,
              document_id: docvTransactionToken,
            });
          },
          onError: onSyncteraVerifyError,
          qrCodeNeeded: !isMobileDevice(),
          disableSmsInput: false,
          closeCaptureWindowOnComplete: true,
          autoOpenTabOnMobile: true,
        };

        window.SocureDocVSDK.launch(
          process.env.REACT_APP_SOCURE_SDK_KEY,
          stakeDebit?.data?.data?.session_token,
          "#socure-doc-v-sdk-container",
          config,
        )
          .then((response) => {
            if (response.result === "error") {
              setIsSDKLoadingError(true);
            } else {
              setIsSDKLoaded(true);
            }
          })
          .catch(() => setIsSDKLoadingError(true));
      } else {
        navigate(locationState?.previousPathname || -1);
      }
    }
  }, [isFetchingStakeDebit, isSDKLoaded, VerifyPersonSynctera, stakeDebit, locationState?.previousPathname, navigate]);

  return (
    <div className="authenticated-page verify-stake-checking-page">
      <header>
        <button className="back-button" onClick={() => navigate(locationState?.previousPathname || -1)}>
          <ArrowLeft />
        </button>
        <StakeLogo className="stake-logo" />
      </header>
      <div
        id="socure-doc-v-sdk-container"
        className={(isFetchingStakeDebit && !isSDKLoaded) || isSDKLoadingError ? "d-none" : ""}
      ></div>
      {isSDKLoadingError && (
        <div className="error-content">
          <CloseWithShadow />
          <div className="error-description">{contactStakeIfErrorPersistsMessage}</div>
        </div>
      )}
      {isFetchingStakeDebit && !isSDKLoaded && (
        <div className="loading-content">
          <CircularProgress />
        </div>
      )}
    </div>
  );
}
